import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    value: [],
}

export const userSlice:any = createSlice({
    name: 'USER',
    initialState,
    reducers: {
        setUser: (state: any, action: any) => {
            state.value = action.payload
        },
    },
})

export const { setUser } = userSlice.actions

export default userSlice.reducer